<template>
	<q-card
		class="full-width shadow-transition full-height relative-position cursor-pointer card-course"
		:class="class_hover"
		@mouseover="class_hover = 'shadow-5'"
		@mouseleave="class_hover = ''"
	>
		<img
			:src="getImage"
			@error="getImageError"
			:alt="
				course.group_training_image_alt_texts?.length
					? course.group_training_image_alt_texts[0].alt_text
					: ''
			"
			@click="openCourse()"
			:style="$q.platform.is.desktop ? 'min-height: 135px;' : ''"
		/>

		<q-card-section @click="openCourse()">
			<div class="text-subtitle2 title">
				{{ course.title }}
			</div>
		</q-card-section>
	</q-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'CourseCardPortfolio',

	props: ['course'],

	data() {
		return {
			class_hover: '',
		}
	},

	computed: {
		...mapGetters({
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getImage() {
			const img = this.course.image
			return img ? img : 'placeholders/course.png'
		},
	},

	methods: {
		openCourse() {
			this.$router.push({
				name: 'portfolio_course',
				params: { slug: this.course.slug },
			})
		},

		getImageError(event) {
			const obj = this.clients.find((obj) => obj.id === this.id_user_client_selected)
			if (obj) {
				if (
					obj.group_training_placeholder !== 'https://image.jpg' &&
					obj.group_training_placeholder !== ''
				)
					event.target.src = obj.group_training_placeholder
				else event.target.src = 'placeholders/course.png'
			} else event.target.src = 'placeholders/course.png'
		},
	},
}
</script>

<style lang="scss" scoped>
@media (max-width: $breakpoint-xs) {
	.card-course {
		min-height: 200px;
	}
}
@media (min-width: $breakpoint-xs) {
	.card-course {
		min-height: 300px;
	}
}
.title {
	line-height: 1rem;
	min-height: 2rem;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.hoverable-icon {
	&:hover {
		color: #000;
	}
}
</style>
